// extracted by mini-css-extract-plugin
export var footer = "_pj-5";
export var fulfillmentInput = "_pj-0";
export var shipDateInput = "_pj-1";
export var shipmentModal = "_pj-2";
export var shipmentModalContent = "_pj-3";
export var tableContainer = "_pj-4";